// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"486":"5c53c917","600":"ab436143","642":"0c9a5f7f","672":"b44d0944","675":"1d6b446c","963":"fb75e563","977":"0b56fd14","995":"fee3cc31"}[chunkId] + ".chunk.css";
};